import React, { PureComponent, Component } from 'react'

import Dialog from '@material-ui/core/Dialog'
import TextField from '@material-ui/core/TextField'

import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button';
import SelectList from '../SelectList'
import { alertActions } from '../../actions/alert.actions';
import { getFirebase } from 'react-redux-firebase'
import { dockPadEntityMapToList } from '../../containers/DockPadFormTemplates';
import { getNewId } from '../../actions/home.actions';
import { LookaheadTag, LookaheadTagStatus } from '../../models/LookaheadTag';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { Trade } from '../../models/Trade';
import classNames from 'classnames';
import { ColumnType } from '../PhasePlan/Column';
import { Constraint, ConstraintStatus } from '../../models/Constraint';
import MaterialTable, { MTableToolbar } from 'material-table'
import EditIcon from '@material-ui/icons/Edit';

import moment, { Moment } from 'moment'
import { DatePicker } from "material-ui-pickers";
import { Chip, IconButton } from '@material-ui/core';
import { PhaseTag } from '../../models/PhaseTag';


const _ = require('lodash')

interface IFormConstraint {
    dateCreated: number;
    identifyBy: string;
    assignedTo?: string;
    description?: string;
    dueByDate: number;
    tagId?: string;
    status: ConstraintStatus;
}

interface Props {
    classes: ClassNameMap;
    closeDialogValue: () => Promise<void>;
    projectUsers: Record<string, any>;
    type: ColumnType;
    isConstraintLogDialogOpen: boolean;
    constraintList: Constraint[];
    phasePlanTags: Record<string, PhaseTag>;
    openConstraintDialog: (constraintId? :string) => void
    phaseTags: Record<string, PhaseTag>;
    lookaheadTags: Record<string, LookaheadTag>;
    pathName: string;

}




class ConstraintLogDialog extends Component<Props> {
    constructor(props: Props) {
        super(props)
    }

    shouldComponentUpdate(nextProps: Props) {
      if(nextProps.isConstraintLogDialogOpen !== this.props.isConstraintLogDialogOpen) {
        return true
      }

      if(!_.isEqual(nextProps.constraintList, this.props.constraintList)) {
        return true
      }

      return false
    }


    async closeDialog() {
        const { closeDialogValue } = this.props
        closeDialogValue()
    }

    renderTableContainer() {
        return (
          <div>
            {this.renderConstraintTable()}
          </div>
        );
    }

    getTags = () => {
        const { pathName, lookaheadTags, phaseTags  } = this.props
        if(pathName === '/phasePlan') {
            return phaseTags
        }

        if(pathName === '/lookahead') {
            return lookaheadTags
        }

        return {}
    }

    renderTag = (rowData:Constraint) => {
        if(!!this.getTags() && !!this.getTags()[rowData.tagId]) {
        const tag = this.getTags()[rowData.tagId] as PhaseTag

        return tag.name
        }
    }
    
    renderIdentifyByData(rowData:Constraint) {
        const { projectUsers } = this.props;
        if(!rowData.identifyBy || !projectUsers[rowData.identifyBy]) {
          return ''
        }
    
        return `${projectUsers[rowData.identifyBy].first_name} ${projectUsers[rowData.identifyBy].last_name} - ${projectUsers[rowData.identifyBy].email}`
    }
    
    renderStatusData(rowData: Constraint) {
        const { classes } = this.props;
    
        if(rowData.status === ConstraintStatus.Todo) {
          return <Chip label="Todo"className={classNames(classes.issuesTableStatusNotDone)} />
        }
    
        if (rowData.status === ConstraintStatus.WorkingOn){
          return <Chip label="Working On" className={classNames(classes.issuesTableStatusDone)} />
        }
    
        if (rowData.status === ConstraintStatus.Done){
          return <Chip label="Done" className={classNames(classes.issuesTableStatusDone)} />
        }
    
        if (rowData.status === ConstraintStatus.DoneDone){
          return <Chip label="Done Done" className={classNames(classes.issuesTableStatusDone)} />
        }
    
        return <Chip label="Error" className={classNames(classes.issuesTableStatusError)}/>
    }

    renderAssignedTo = (rowData: Constraint) => {
        console.log('renderIdentifyByData', rowData.assignedTo, this.props.projectUsers, )
        const { projectUsers } = this.props;
        if(!rowData.assignedTo || !projectUsers[rowData.assignedTo]) {
          return ''
        }
    
        return `${projectUsers[rowData.assignedTo].first_name} ${projectUsers[rowData.assignedTo].last_name} - ${projectUsers[rowData.assignedTo].email}`
    }


    renderEdit(rowData:Constraint) {
        const { openConstraintDialog, classes } = this.props;
        return (
            <IconButton
                onClick={() => {
                openConstraintDialog(rowData.uid);
                }}>
                <EditIcon
                className={classNames(classes.AllTasksScreenVisibilityIcon)}
                />
            </IconButton>
        )
    }

    renderConstraintTable() {

        const { constraintList } = this.props;
    
        return (
          <MaterialTable

            components={{
              Toolbar: props => (
                <div >
                  <MTableToolbar {...props} />
                </div>
              )
            }}
            columns={[
              {
                title: '',
                field: 'edit',
                render: rowData => {
                  return this.renderEdit(rowData)
                },
                cellStyle: {
                  backgroundColor: '#f9fcfd',
                  padding: '4px'
                },
                headerStyle: {
                   padding: '4px'
               }
              },
              {
                title: 'Date Identify',
                render: (rowData:Constraint) => {
                  return moment(rowData.dateCreated).format('L')
                },
                cellStyle: {
                  backgroundColor: '#f9fcfd',
                  padding: '4px 16px'
                },
                headerStyle: {
                   padding: '4px 16px'
               }
              },
              {
                title: 'Individual Identifying Constraint',
                field: 'identifyBy',
                render: rowData => {
                  return this.renderIdentifyByData(rowData)
                },
                cellStyle: {
                  backgroundColor: '#f9fcfd',
                  padding: '4px 16px'
                },
                headerStyle: {
                   padding: '4px 16px'
               }
              },
              {
                title: 'Description',
                field: 'description',
                cellStyle: {
                  backgroundColor: '#f9fcfd',
                  padding: '4px 16px'
                },
                headerStyle: {
                   padding: '4px 16px'
               }
              },
              
              {
                title: 'Date to be Resolved',
                field: 'dueByDate',
                render: (rowData:Constraint) => {
                  return moment(rowData.dueByDate).format('L')
                },
                cellStyle: {
                  backgroundColor: '#f9fcfd',
                  padding: '4px 16px'
                },
                headerStyle: {
                   padding: '4px 16px'
               }
              },
              {
                title: 'Tag',
                render: rowData => {
                  return this.renderTag(rowData)
                },
                cellStyle: {
                  backgroundColor: '#f9fcfd',
                  padding: '4px 16px'
                },
                headerStyle: {
                   padding: '4px 16px'
               }
              },
              {
                title: 'Responsible Individual for Resolving',
                render: rowData => {
                  return this.renderAssignedTo(rowData)
                },
                cellStyle: {
                  backgroundColor: '#f9fcfd',
                  padding: '4px 16px'
                },
                headerStyle: {
                   padding: '4px 16px'
               }
              },
              {
                title: 'Status',
                field: 'status',
                render: rowData => {
                  return this.renderStatusData(rowData)
                },
                cellStyle: {
                  backgroundColor: '#f9fcfd',
                  padding: '4px 16px'
                },
                headerStyle: {
                   padding: '4px 16px'
               }
              }
            ]}
            data={constraintList}
            title=""
            options={{
              pageSize: 10
            }}
          />
        );
    }

    render() {
        const { isConstraintLogDialogOpen, classes  } = this.props;
        return (
          <Dialog
            maxWidth='sm'
            fullWidth={true}
            open={!!isConstraintLogDialogOpen}
            onBackdropClick={this.closeDialog}
          >
              <DialogContent>
                <div className={classNames(classes.DialogFormTitle, classes.DialogFormHelpInfoTitle)}>
                    <p className={classes.DialogFormTitleText}>
                        Constraint Log
                    </p>
                </div>
                <div className={classes.DialogFormContent} >
                    {this.renderTableContainer()}
                </div>


              </DialogContent>
              <DialogActions>
                <Button onClick={this.closeDialog.bind(this)}  color="primary"> Close </Button>
              </DialogActions>
          </Dialog>
        )
    }
    
}


export default ConstraintLogDialog
  


// WEBPACK FOOTER //
// ./src/components/Dialogs/ConstraintLogDialog.tsx